define('type/article/Serum.Article.UniverseRelationDerepetizer',[],function () {
  'use strict';

  function queryAll(selector, context) {
    return [].slice.call((context || document).querySelectorAll(selector));
  }

  function isUniqueInArray(value, array) {
    return array.indexOf(value) === -1 && array.push(value);
  }

  function replaceDuplicates(nextId, seenRelationIds, duplicates) {
    var node = document.createElement('div');
    var ajax = new window.XMLHttpRequest();

    ajax.onload = function () {
      node.innerHTML = ajax.responseText; //Convert response from html to DOM

      queryAll('.article-reference,.recipe-reference', node).every(function (relation) {
        var relationId = relation.querySelector('a[data-id]').getAttribute('data-id');

        if (isUniqueInArray(relationId, seenRelationIds)) {
          var toBeReplaced = duplicates.shift();
          var parent = toBeReplaced.parentElement;
          // remove and append instead of replace to preserve ordering
          parent.removeChild(toBeReplaced);
          parent.appendChild(relation);
        }

        return duplicates.length; //Stops loop if 0
      });

      var next = duplicates.length && node.querySelector('input[name="next-data-id"]');
      if (next) {
        replaceDuplicates(next.value, seenRelationIds, duplicates);
      }
    };
    ajax.open('GET', '/serum/api/render/' + nextId, true);
    ajax.send();
  }

  function fixUniverseRelationRepetitions(context) {
    var seenRelationIds = [];

    queryAll('.universe .relations', context).forEach(function (relations) {
      var duplicates = queryAll('.relation', relations)
        .filter(function (relation) {
          var relationId = relation.getAttribute('data-id');
          var isDuplicate = !isUniqueInArray(relationId, seenRelationIds);

          return isDuplicate;
        });

      var next = duplicates.length && relations.parentNode.querySelector('.flow-page-forward');
      if (next) {
        // ensure container uses nrk-grid, to avoid white-space issues
        relations.classList.add('nrk-grid');
        replaceDuplicates(next.getAttribute('data-id'), seenRelationIds, duplicates);
      }
    });
  }

  return {
    derepetize: fixUniverseRelationRepetitions
  };
});

